import { BROADCAST_START_PROGRAM } from 'actions/Types';

function startProgram(state = false, action) {
  if (action.type === BROADCAST_START_PROGRAM) return true;

  return state;
}

export default startProgram;
